import { format } from 'date-fns'
import * as React from 'react'

const formatDate = (date: Date, formatString: string): string => {
  return format(date, formatString)
}

const DateDisplay = (props: DateProps): JSX.Element => (
  <time {...props}>{formatDate(props.date, props.format)}</time>
)

interface DateProps extends React.HTMLAttributes<HTMLSpanElement> {
  date: Date
  format: string
}

export default DateDisplay



// WEBPACK FOOTER //
// ./src/components/_atoms/dateDisplay.tsx